import { render, staticRenderFns } from "./article-details.vue?vue&type=template&id=59a39312&scoped=true&"
import script from "./article-details.vue?vue&type=script&lang=js&"
export * from "./article-details.vue?vue&type=script&lang=js&"
import style0 from "./article-details.vue?vue&type=style&index=0&id=59a39312&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a39312",
  null
  
)

export default component.exports